(function () {
  'use strict';
  if (window.__isdKachingBridge2026) return;
  window.__isdKachingBridge2026 = true;

  function currentApi() {
    var a = window.kachingCartApi;
    return a && typeof a.openCart === 'function' ? a : null;
  }
  function openKaching() {
    var api = currentApi();
    if (!api) return false;
    var legacy = document.querySelector('[data-sk-drawer="cart"].is-open');
    if (legacy) {
      var close = legacy.querySelector('[data-sk-close]');
      if (close) close.click();
    }
    api.openCart({ refetchCart: true });
    return true;
  }

  if (window.ISD && window.ISD.cart && typeof window.ISD.cart.open === 'function') {
    var fallbackOpen = window.ISD.cart.open;
    window.ISD.cart.open = function () {
      if (!openKaching()) return fallbackOpen.apply(this, arguments);
    };
  }

  document.addEventListener('isd:cart:open', function (event) {
    if (!currentApi()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openKaching();
  }, true);

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 ||
        event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ||
        !event.target || !event.target.closest) return;

    var trigger = event.target.closest('[data-sk-open="cart"],a[href="/cart"],a[href="/cart/"],a[href$="/cart"],a[href$="/cart/"]');
    if (!trigger || !openKaching()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  var announcement = null;
  function adjustAnnouncement() {
    if (!announcement || !announcement.isConnected) {
      announcement = document.querySelector('[class^="sk-ann-"]');
    }
    var height = announcement ? announcement.getBoundingClientRect().height : 0;
    var remaining = Math.max(0, height - window.scrollY);
    document.documentElement.style.setProperty('--isd-ann-offset', Math.round(remaining) + 'px');
  }

  var scheduled = false;
  function scheduleAnnouncement() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      adjustAnnouncement();
    });
  }
  window.addEventListener('scroll', scheduleAnnouncement, { passive: true });
  window.addEventListener('resize', scheduleAnnouncement, { passive: true });
  document.addEventListener('shopify:section:load', scheduleAnnouncement);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adjustAnnouncement, { once: true });
  } else {
    adjustAnnouncement();
  }
})();